import { render, staticRenderFns } from "./PpgTable.vue?vue&type=template&id=3b911232&scoped=true&"
import script from "./PpgTable.vue?vue&type=script&lang=js&"
export * from "./PpgTable.vue?vue&type=script&lang=js&"
import style0 from "./PpgTable.vue?vue&type=style&index=0&id=3b911232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b911232",
  null
  
)

export default component.exports